import { useEffect, useState } from "react";
import { EditTwoTone } from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Spin,
  message,
  notification,
} from "antd";

import {
  callFetchEmailFollowById,
  callUpdateEmailFollow,
} from "../../../../config/api";
import { createPost } from "../../../../types/backend";

const ModalEmailFollow = ({
  id,
  handleFetchEmailFollow,
}: {
  id: string;
  handleFetchEmailFollow: any;
}): JSX.Element => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const showModal = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const fetchEmailFollowById = async () => {
    const result: any = await callFetchEmailFollowById(id);
    form.setFieldsValue(result.data);
  };

  useEffect(() => {
    fetchEmailFollowById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, open]);

  const onFinish = async (values: createPost) => {
    setLoading(true);
    const res: any = await callUpdateEmailFollow(id, values);
    if (res && res.statusCode === 200) {
      handleFetchEmailFollow();
      message.success("update success!");
      setOpen(false);
    } else {
      notification.error({
        message: "Đã có lỗi xảy ra",
        description: res.message,
      });
    }
    setLoading(false);
  };

  return (
    <Spin spinning={loading}>
      <Button
        style={{ border: "1px solid #f57800" }}
        type="primary"
        ghost
        onClick={showModal}
      >
        <EditTwoTone twoToneColor="#f57800" style={{ cursor: "pointer" }} />
      </Button>
      <Modal
        title="Chỉnh sửa email theo dõi"
        open={open}
        onOk={() => {
          form.submit();
        }}
        okText="Lưu"
        cancelText="Hủy"
        maskClosable={false}
        width={840}
        onCancel={onClose}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          hideRequiredMark
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="email"
                label="Email"
                rules={[{ required: true, message: "Please enter title" }]}
              >
                <Input placeholder="Please enter title" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </Spin>
  );
};

export default ModalEmailFollow;
